import React, { useState, Fragment } from "react";
import { Grid } from "antd";
import { useTranslation } from "react-i18next";

import { Button, Box, Pagination, Select } from "components";
import { DownloadIcon, DownArrow } from "icons";
import { localStorageHelper } from "utils";
import { CheckboxStyled } from "screens/account/Account.style";
import {
  PaginationWrapper,
  ContentWrapper,
  SituationTableStyled,
  WrapperSizeChange,
  DownloadButtonsContainer,
  WapperSelectTimeForItem,
  PaginationContainer,
  NotifyWrapper,
  CheckboxText,
  SelectBlock,
} from "./Stress.style";
import ConfirmInterviewModal from "./ConfirmInterviewModal";

const tempDatas = [
  {
    id: 0,
    display_name: "小邦 将輝",
    date: "2022.11.12",
    stress_situation: "実施済",
    affiliation: "開発部",
    gender: "男性",
    checkbox: false,
  },
  {
    id: 1,
    display_name: "福永 哲也",
    date: "2022.06.11",
    stress_situation: "未実施",
    affiliation: "営業部",
    gender: "女性",
    checkbox: true,
  },
  {
    id: 2,
    display_name: "小邦 将輝",
    date: "",
    stress_situation: "未実施",
    affiliation: "営業部",
    gender: "男性",
    checkbox: true,
  },
  {
    id: 3,
    display_name: "福永 哲也",
    date: "2022.04.06",
    stress_situation: "未実施",
    affiliation: "営業部",
    gender: "女性",
    checkbox: true,
  },
  {
    id: 4,
    display_name: "小邦 将輝",
    date: "2022.05.02",
    stress_situation: "未実施",
    affiliation: "営業部",
    gender: "男性",
    checkbox: true,
  },
  {
    id: 5,
    display_name: "福永 哲也",
    date: "",
    stress_situation: "未実施",
    affiliation: "営業部",
    gender: "女性",
    checkbox: true,
  },
];

const { useBreakpoint } = Grid;

const StressSituationNotify: React.FC = () => {
  const currentLanguage = localStorageHelper.getItem("i18nextLng");
  const { t }: any = useTranslation("translation", {
    keyPrefix: "stress-check",
  });
  const { t: t1 }: any = useTranslation("translation", {
    keyPrefix: "mental-health",
  });
  const { t: t2 }: any = useTranslation("translation", {
    keyPrefix: "user-list",
  });
  const { t: t3 }: any = useTranslation("translation", {
    keyPrefix: "message-delivery",
  });

  const screens = useBreakpoint();
  const [confirmModalVisible, setConfirmModalVisible] =
    useState<boolean>(false);
  const [input, setInput] = useState({
    limit: 50,
    page: 1,
  });
  const totalRecord = 0;

  const handleCancel = () => {
    setConfirmModalVisible(false);
  };

  const returnStatus = (status: string) => {
    switch (status) {
      case "実施済":
        return "#B7B7B7";
      default:
        return;
    }
  };

  const columns = [
    {
      title: () => {
        return (
          <CheckboxText>
            <CheckboxStyled />
            <div>{t2("full-name")}</div>
          </CheckboxText>
        );
      },
      dataIndex: "display_name",
      key: "display_name",
      width: 132,
      fixed: window.innerWidth < 576 ? "" : "left",
      render: (text: string, record: any) => {
        return (
          <CheckboxText>
            {record?.checkbox ? (
              <CheckboxStyled />
            ) : (
              <div style={{ width: 20, height: 20 }}></div>
            )}
            <div>{text}</div>
          </CheckboxText>
        );
      },
    },
    {
      title: t1("implementation-date"),
      dataIndex: "date",
      key: "date",
      width: 132,
      render: (text: string) => {
        if (!text) {
          return <div>-</div>;
        }
        return <div>{text}</div>;
      },
    },
    {
      title: t3("belongs"),
      dataIndex: "affiliation",
      key: "affiliation",
      width: 94,
    },
    {
      title: t2("gender"),
      dataIndex: "gender",
      key: "gender",
      width: 82,
    },
    {
      title: t("situation"),
      dataIndex: "stress_situation",
      key: "stress_situation",
      width: 102,
      render: (text: string, record: any) => {
        return (
          <div
            style={{
              color: returnStatus(record?.stress_situation),
              fontWeight: record?.stress_situation === "実施済" ? 500 : 400,
            }}
          >
            {text}
          </div>
        );
      },
    },
  ];

  const handleChangePage = (page: number) => {
    setInput((prevState: any) => ({ ...prevState, page }));
  };

  const handleOnChangeSizeChange = (limit: number) => {
    setInput((prevState: any) => ({ ...prevState, limit, page: 1 }));
  };

  const DownloadMenu = () => (
    <DownloadButtonsContainer>
      <Button
        icon={
          <DownloadIcon
            width="14px"
            height="14px"
            fill="currentColor"
            style={{ position: "absolute", left: 4, top: 4 }}
          />
        }
        name={t2("excel-output")}
        background="#2AC769"
        color="#FFFFFF"
        border="none"
        fontSize={12}
        lineHeight="17px"
        fontWeight={700}
        padding="3px 8px 3px 14px"
      />
      <Button
        icon={
          <DownloadIcon
            width="14px"
            height="14px"
            fill="currentColor"
            style={{ position: "absolute", left: 4, top: 4 }}
          />
        }
        name={t2("pdf-output")}
        background="#2AC769"
        color="#FFFFFF"
        border="none"
        fontSize={12}
        lineHeight="17px"
        fontWeight={700}
        padding="3px 8px 3px 14px"
      />
    </DownloadButtonsContainer>
  );

  const ActionSection = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "8px 8px 9px",
        }}
      >
        <NotifyWrapper>
          <DownArrow />
          <div className="notify-title">{t1("checked-user")}</div>
          <div className="single-button">
            <Button
              color="#FFFFFF"
              fontSize={12}
              fontWeight={700}
              lineHeight="12px"
              background="#2F8CAE"
              padding="6px 12px 5px"
              name={t("send-notification")}
              bdr="6px"
              border="none"
              disabled={false}
              onClick={() => setConfirmModalVisible(true)}
            />
          </div>
        </NotifyWrapper>
        {!screens.xs && <DownloadMenu />}
      </div>
    );
  };

  const ShowPagination = () => {
    return totalRecord > input.limit ? (
      <PaginationWrapper>
        <Pagination
          current={input.page}
          onChange={handleChangePage}
          pageSize={input.limit}
          total={10}
          showSizeChanger={false}
          showLessItems={!screens.xl}
        />
      </PaginationWrapper>
    ) : (
      <Fragment></Fragment>
    );
  };

  return (
    <Box title={"ストレスチェック（59）状況"} padding="16px 16px 32px">
      <div style={{ padding: 16, marginBottom: 24, background: "#FBFBFB" }}>
        <div
          style={{
            fontSize: 18,
            lineHeight: "18px",
            fontWeight: 700,
            marginBottom: 16,
          }}
        >
          {t("search-conditions")}
        </div>
        <SelectBlock>
          <WapperSelectTimeForItem>
            <div className="bor-div-time">
              <div className="dright">
                <Select
                  options={[]}
                  width={"100px"}
                  placeholder="2022年"
                  height="30px"
                  //   defaultValue={item.end_hour}
                />
                <Select
                  options={[]}
                  width={"82px"}
                  placeholder="01月"
                  height="30px"
                  marginForm="0px 0px 0px 8px"
                  //   defaultValue={item.end_minute}
                />
              </div>
            </div>
          </WapperSelectTimeForItem>
          <Select
            options={[]}
            width={"100px"}
            placeholder="未実施"
            height="30px"
            //   defaultValue={item.end_hour}
          />
          <Button
            color="#FFFFFF"
            fontSize={16}
            fontWeight={700}
            lineHeight="23px"
            background={"#2AC769"}
            padding="4px 34px 3px"
            name={t2("search")}
            bdr="6px"
            border="none"
          />
        </SelectBlock>
      </div>
      <PaginationContainer
        style={{
          alignItems: "flex-start",
        }}
      >
        <WrapperSizeChange>
          <div style={{ fontWeight: 500 }}>{t2("record")}</div>
          <Select
            defaultValue={50}
            options={[]}
            onChange={handleOnChangeSizeChange}
          />
        </WrapperSizeChange>
        <ShowPagination />
      </PaginationContainer>
      {screens.xs && <DownloadMenu />}
      <ContentWrapper>
        <SituationTableStyled
          dataSource={tempDatas}
          columns={columns}
          actionSection={<ActionSection />}
          scroll={{ x: "max-content" }}
          // loading={isLoading}
        />
      </ContentWrapper>
      {totalRecord > input.limit && <ShowPagination />}
      {/* <ConfirmInterviewModal
        isVisible={confirmModalVisible}
        handleCancel={handleCancel}
        label="通知送信"
      /> */}
    </Box>
  );
};

export default StressSituationNotify;
